import type { ReactNode } from 'react';
import SectionTitle from '@/components/SectionTitle';
import useScrollReveal from '@/hooks/useScrollReveal';
import styles from './index.module.scss';

export interface SectionProps {
  className?: string;
  title?: string;
  subTitle?: string;
  /** 全幅背景图：高度铺满、水平居中，变窄时裁两侧。 */
  background?: string;
  children?: ReactNode;
}

export default function Section({ className, title, subTitle, background, children }: SectionProps) {
  const { ref, revealProps } = useScrollReveal<HTMLElement>();

  const sectionClass = [styles.section, background ? styles.hasBg : '', className].filter(Boolean).join(' ');

  return (
    <section ref={ref} className={sectionClass}>
      {background ? (
        <div className={styles.bgMedia}>
          <img src={background} alt="" loading="lazy" />
        </div>
      ) : null}
      <div className={styles.inner} {...revealProps}>
        {title ? <SectionTitle title={title} subtitle={subTitle} /> : null}
        {children}
      </div>
    </section>
  );
}
